function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getEnterpriseDaily, getEnterpriseUsersApi } from '@/api/enterprise';
import { deleteDailyApi, submitStatisticsApi as _submitStatisticsApi, noSubmitListApi, scheduleListApi } from '@/api/user';
import addBox from './components/addBox';
import calendar from './components/calendar';
export default {
  name: 'IndexVue',
  components: {
    addBox: addBox,
    calendar: calendar,
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    }
  },
  data: function data() {
    return {
      loading: false,
      currentTime: '',
      submitType: '1',
      value: new Date(),
      active: false,
      submitFrom: {
        page: 1,
        limit: 15
      },
      totalSubmit: 0,
      fromList: [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('toptable.thisweek'),
        val: 'week'
      }, {
        text: this.$t('toptable.thismonth'),
        val: 'month'
      }, {
        text: this.$t('toptable.lastmonth'),
        val: 'last month'
      }],
      dailyData: [{
        name: this.$t('user.work.writedaily'),
        id: 1
      }, {
        name: this.$t('user.work.writedailyweek'),
        id: 2
      }, {
        name: this.$t('user.work.writedailymonth'),
        id: 3
      }, {
        name: '填写汇报',
        id: 4
      }],
      options: [{
        name: this.$t('user.work.dailyday'),
        id: 0
      }, {
        name: this.$t('user.work.weekday'),
        id: 1
      }, {
        name: this.$t('user.work.monthday'),
        id: 2
      }, {
        name: '汇报',
        id: 3
      }],
      weekInfo: '',
      dailyName: '',
      dailyIndex: 1,
      totalPage: 0,
      timeVal: [this.$moment().subtract(1, 'months').format('YYYY/MM/DD'), this.$moment().format('YYYY/MM/DD')],
      year: '',
      tableFrom: {
        page: 1,
        limit: 15,
        type: 0,
        types: 0,
        time: this.$moment().subtract(1, 'months').format('YYYY/MM/DD') + '-' + this.$moment().format('YYYY/MM/DD'),
        user_id: '',
        scope_frame: 'self'
      },
      table: [],
      total: '',
      submit: '',
      no_submit: '',
      calendar: [],
      disabled: false,
      pickerOptions: this.$pickerOptionsTimeEle,
      tableData: [],
      departmentalData: [],
      editId: 0,
      editData: {},
      nowDateStar: null,
      // 今天时间0点时间戳
      nowDateEnd: null,
      // 今天时间23:59:59 时间戳
      needList: [],
      finishList: '',
      time: this.$moment(new Date()).format('yyyy-MM-DD'),
      windowHeight: 0,
      search: [{
        field_name: '汇报类型',
        field_name_en: 'types',
        form_value: 'select',
        data_dict: [{
          name: this.$t('user.work.dailyday'),
          id: 0
        }, {
          name: this.$t('user.work.weekday'),
          id: 1
        }, {
          name: this.$t('user.work.monthday'),
          id: 2
        }, {
          name: '汇报',
          id: 3
        }],
        value: [0]
      }, {
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker',
        data_dict: [this.$moment().subtract(1, 'months').format('YYYY/MM/DD'), this.$moment().format('YYYY/MM/DD')]
      }]
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  activated: function activated() {
    this.$refs.elTable.doLayout();
  },
  created: function created() {
    this.windowHeight = window.innerHeight - 330;
    this.getList();
    this.nowDateStar = parseInt(this.$moment(new Date()).startOf('day').format('x'));
    this.nowDateEnd = parseInt(this.$moment(new Date()).endOf('day').format('x'));
    this.dailyName = this.dailyData[this.dailyIndex - 1].name;
    this.getUsersOption();
  },
  mounted: function mounted() {
    this.getDate();
    this.getDailyTodoInfo();
  },
  methods: {
    updateValue: function updateValue(newVal) {
      this.finishList = newVal;
    },
    confirmData: function confirmData(data) {
      if (data && data == 'reset') {
        this.tableFrom = {
          page: 1,
          limit: 15,
          type: 0,
          types: 0,
          time: this.$moment().subtract(1, 'months').format('YYYY/MM/DD') + '-' + this.$moment().format('YYYY/MM/DD'),
          user_id: '',
          scope_frame: 'self'
        };
        this.timeVal = [this.$moment().subtract(1, 'months').format('YYYY/MM/DD'), this.$moment().format('YYYY/MM/DD')];
        this.search[1].data_dict = this.timeVal;
      } else {
        this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
      }
      this.getList();
    },
    // 获取待办列表
    getDailyTodoInfo: function getDailyTodoInfo() {
      var _this = this;
      var start_time = this.$moment(this.time).format('YYYY-MM-DD') + ' 00:00:00';
      var end_time = this.$moment(this.time).format('YYYY-MM-DD') + ' 23:59:59';
      var data = {
        start_time: start_time,
        end_time: end_time,
        cid: [1, 2, 3, 4, 5, 6],
        period: 1
      };
      scheduleListApi(data).then(function (res) {
        res.data.forEach(function (item) {
          item['checked'] = false;
        });
        _this.needList = res.data.filter(function (item) {
          return [0, 1, -1].includes(item.finish);
        });
        var data = res.data.filter(function (item) {
          return item.finish === 3;
        }).map(function (item) {
          return item.title;
        }).join('\n');
        _this.finishList = data;
      });
    },
    // 获取日期
    getDate: function getDate() {
      this.currentTime = this.$moment().subtract('day').format('YYYY-MM-DD'); // 当天日期
      this.thePreviousDay = this.$moment().subtract(1, 'day').format('YYYY-MM-DD'); // 前一天日期
      this.thePreviousDay = this.$moment(this.thePreviousDay).format('YYYY年MM月DD日'); // 格式化日期
    },
    // 获取未提交的日历
    submitStatisticsApi: function submitStatisticsApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                time: _this2.calendarTime,
                types: _this2.tableFrom.types,
                frame_id: _this2.tableFrom.frame_id,
                type: _this2.tableFrom.type == 0 ? '1' : '0'
              };
              _context.next = 3;
              return _submitStatisticsApi(data);
            case 3:
              result = _context.sent;
              _this2.calendar = result.data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onchangeTime: function onchangeTime() {
      this.tableFrom.page = 1;
      if (this.timeVal) {
        this.tableFrom.time = this.timeVal[0] ? this.timeVal.join('-') : '';
      } else {
        this.tableFrom.time = '';
      }
      this.selectTypes();
    },
    // 切换日历月份触发的回调
    switchTime: function switchTime(data) {
      this.calendarTime = this.$moment(data.startTime).format('YYYY/MM/DD') + '-' + this.$moment(data.endTime).format('YYYY/MM/DD');
      this.submitStatisticsApi();
    },
    getUsersOption: function getUsersOption() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getEnterpriseUsersApi();
            case 2:
              result = _context2.sent;
              _this3.usersOption = result.data ? result.data : [];
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setOptions: function setOptions() {
      this.fromList = [{
        text: this.$t('toptable.all'),
        val: ''
      }, {
        text: this.$t('toptable.thisweek'),
        val: 'week'
      }, {
        text: this.$t('toptable.thismonth'),
        val: 'month'
      }, {
        text: this.$t('toptable.lastmonth'),
        val: 'lastmonth'
      }];
    },
    getList: function getList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loading = true;
              _context3.next = 3;
              return getEnterpriseDaily(_this4.tableFrom);
            case 3:
              result = _context3.sent;
              data = result.data;
              if (data.list.length) {
                data.list.forEach(function (el) {
                  el.isEdit = true;
                });
              }
              _this4.totalPage = data.count;
              _this4.tableData = data.list;
              _this4.loading = false;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    tableList: function tableList() {
      this.getList();
    },
    onEdit: function onEdit(id, type, data) {
      this.editId = id;
      this.editData = data;
      this.$refs.addBox.getInfo(id, type, data);
    },
    onCheck: function onCheck(id, type, data) {
      this.editId = id;
      this.dailyIndex = data.types;
      this.$refs.addBox.getInfo(id, type, data);
    },
    // 删除当日当周当月日报
    onDelete: function onDelete(id) {
      var _this5 = this;
      this.$modalSure('确认删除当前汇报').then(function () {
        deleteDailyApi(id).then(function (res) {
          _this5.tableFrom.page = 1;
          _this5.getList();
        });
      });
    },
    // 添加日报
    addDaily: function addDaily(val) {
      this.editId = 0;
      this.editData = {};
      this.$refs.addBox.drawer = true;
      this.$refs.addBox.editType = false;
      this.$refs.addBox.approveApplyList();
      this.$refs.addBox.disabled;
      this.disabled = this.$refs.addBox.disabled;
    },
    handleClick: function handleClick() {
      this.tableFrom.page = 1;
      this.tableFrom.user_id = '';
      this.getList();
    },
    // 获取未提交的汇报表格数据
    noSubmitList: function noSubmitList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                time: _this6.leftTime,
                types: _this6.tableFrom.types,
                frame_id: _this6.tableFrom.frame_id,
                page: _this6.submitFrom.page,
                limit: _this6.submitFrom.limit
              };
              _context4.next = 3;
              return noSubmitListApi(data);
            case 3:
              result = _context4.sent;
              _this6.totalSubmit = result.data.count;
              _this6.table = result.data.list;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 搜索
    selectTypes: function selectTypes() {
      if (this.tableFrom.types == 0) {}
      this.tableFrom.page = 1;
      this.getList();
    },
    // 清空
    reset: function reset() {
      var _this7 = this;
      this.leftTime = this.$moment().subtract(1, 'day').format('YYYY/MM/DD') + '-' + this.$moment().subtract(1, 'day').format('YYYY/MM/DD');
      this.thePreviousDay = this.$moment().subtract(1, 'day').format('YYYY年MM月DD日');
      this.tableFrom.types = 0;
      this.tableFrom.time = this.$moment().subtract(1, 'months').format('YYYY/MM/DD') + '-' + this.$moment().format('YYYY/MM/DD');
      this.tableFrom.user_id = '';
      this.tableFrom.frame_id = '';
      this.tableFrom.page = 1;
      this.timeVal = [this.$moment().subtract(1, 'months').format('YYYY/MM/DD'), this.$moment().format('YYYY/MM/DD')];
      setTimeout(function () {
        _this7.$refs.week.removeStyle();
        _this7.$refs.week.value = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
      }, 300);
      this.getList();
    },
    getDailyTypes: function getDailyTypes(type) {
      var str = '';
      this.options.map(function (value) {
        if (value.id === type) {
          str = value.name;
        }
      });
      return str;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.page = 1;
      this.tableFrom.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleDaily: function handleDaily(command) {
      this.dailyIndex = command;
      this.dailyName = this.dailyData[command - 1].name;
      this.addDaily('fillInTheReport');
    }
  }
};